import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Btn, H5, H6, Image, P } from "../../../../../../AbstractElements";
import { Cancel, Print, PrintPreview } from "../../../../../../Constants/Constants";
import { PrintModalProps } from "../../../../../../Types/ContactType";
import { dynamicImage } from "../../../../../../Utils";

export const PrintModal:React.FC<PrintModalProps> = ({ printModal, selectedUser, toggleCallback }) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({contentRef});
  
  const printModalToggle = () => {
    toggleCallback(false);
  };
  return (
    <Modal className="modal-bookmark" isOpen={printModal} toggle={printModalToggle} centered>
      <ModalHeader toggle={printModalToggle}>{PrintPreview}</ModalHeader>
      <ModalBody className="list-persons">
        <div className="profile-mail pt-0" ref={contentRef}>
          <div className="d-flex">
            <Image className="img-100 img-fluid m-r-20 rounded-circle" src={dynamicImage(`${selectedUser.avatar}`)} alt="" />
            <div className="flex-grow-1 mt-0">
              <H5>
                <span>{selectedUser.name}</span>
                <span>{selectedUser.surname}</span>
              </H5>
              <P>{selectedUser.email}</P>
            </div>
          </div>
          <div className="email-general">
            <H6>{"General"}</H6>
            <P>
              {"Email Address"} :
              <span className="font-primary" id="mailadd">
                {selectedUser.email}
              </span>
            </P>
          </div>
        </div>
        <Btn color="success" className="me-1" onClick={() => handlePrint()}>
          {Print}
        </Btn>
        <Btn color="primary" onClick={printModalToggle}>
          {Cancel}
        </Btn>
      </ModalBody>
    </Modal>
  );
};
